import { atom, useRecoilState } from "recoil";
import { read, Settings, write } from "../data/settings";

const state = atom<Settings>({
  key: "settingsState",
  default: read(),
});

interface SettingsHook {
  settings: Settings;
  updateSettings: (newSettings: Settings) => void;
}

export function useSettings(): SettingsHook {
  const [settings, setSettings] = useRecoilState(state);

  function updateSettings(newSettings: Settings) {
    const next = Object.assign({}, settings, newSettings);
    setSettings(next);
    write(next);
  }

  return { settings, updateSettings };
}
